export enum AlertTypeEnum {
    Default = 'default',
    Negative = 'negative',
    Positive = 'positive'
}
